import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "news-date-title" }
const _hoisted_2 = { class: "news-date-desc" }
const _hoisted_3 = { class: "news-desc-title" }
const _hoisted_4 = { class: "news-desc-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([['news'], 'news-' + _ctx.size]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoPage(_ctx.content)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([['news-date'], 'news-date-' + _ctx.size])
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.content.addDate.substring(8, 10)), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.content.addDate.substring(0, 7)), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([['news-line'], 'news-line-' + _ctx.size])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([['news-desc'], 'news-desc-' + _ctx.size])
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.content.title || ""), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.doText), 1)
    ], 2)
  ], 2))
}